exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clinic-schedule__title[data-v-5b967a92]{margin-top:24px;font-size:24px;color:var(--theme-text-color);font-weight:500;letter-spacing:.5px;line-height:1.31;margin-bottom:25px}.clinic-schedule__hours input[data-v-5b967a92]{width:40%}.clinic-schedule__button-link[data-v-5b967a92]{text-decoration:none;font-weight:700;font-size:13px;transition:color .2s}.clinic-schedule__button-link[data-v-5b967a92]:hover{color:var(--theme-color)!important}.clinic-schedule__button-link .wabident[data-v-5b967a92]{margin:0 5px;font-size:28px}", ""]);

// exports
